<template>
  <BaseCommonPage>
    <div class="fun_container">
      
      <!-- パンくずリスト -->
      <CreatePlusBreadcrumbs v-bind:otherpages="'guide'" />
      <!-- /パンくずリスト -->

      <div class="container">
        <h1 id="guide_title" class="text-center">
          <!-- Hello! -->
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="13" />
          <br />
          <!-- Create+へようこそ！ -->
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="14" />

        </h1>

        <p class="subtitle">
          <!-- Epson Create＋(エプソン クリエイトプラス)とは -->
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="15" />
        </p>

        <p>
          <!-- エプソンがWeb上で提供するコンテンツが一覧できるプラットフォームです。 -->
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="16" />
          <br />
          <!-- スマホアプリ「Epson Creative Print」またはPCアプリ「Epson Photo+」にダウンロードすることで、無料で印刷できます。 -->
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="17" />
        </p>
        <p>
          <!-- まずはお手持ちのデバイスにアプリのダウンロードをお願いします。 -->
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="18" />
        </p>
        
        <a id="appdl" class="anchor"></a>
        <h3 class="title-func fontsize" id="ingredients">
          <!-- スマホから印刷する -->
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="19" />
        </h3>
        <CreateAppDownloadCreative />
        <!-- AppDownloadCreativeはfcontid等を取得しているため、使えない -->
        
        <h3 class="title-func fontsize" id="ingredients">
          <!-- PCから印刷する -->
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="20" />
        </h3>
        <CreateAppDownloadPhotoPlus />
        <!-- AppDownloadPhotoPlusはfcontid等を取得しているため、使えない -->

        <p class="margin_top1">
          <!-- *Create+の利用には「Epson Creative Print」Ver.7.4以降、 または「Epson Photo+」Ver.3.8以降が必要です。お使いのアプリのVerが古い場合は、最新Verにアップデートをお願いします。 -->
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="22" />
        </p>

        <!-- <div class="wrap_text">
          Create+の使い方
        </div>

        <div class="step">
          <table class="step">
            <tr class="step">
              <td>
                <ol>
                  <li>印刷したいコンテンツを選択</li>
                </ol>
              </td>
            </tr>
          </table>

          <img :src="app_root + '/assets/createplus/img/step1.jpg'" class="center-block margin_top1" alt="">

          <table class="step">
            <tr class="step">
              <td>
                <ol>
                  <li value="2">印刷する用紙サイズを選び、「アプリを起動して印刷する」ボタンを選択</li>
                </ol>
              </td>
            </tr>
          </table>

          <img :src="app_root + '/assets/createplus/img/step2.jpg'" class="center-block margin_top1" alt="">

          <table class="step">
            <tr class="step">
              <td>
                <ol>
                  <li value="3">スマホアプリ「Epson Creative Print」またはPCアプリ「Epson Photo＋」が起動します</li>
                </ol>
              </td>
            </tr>
          </table>

          <img :src="app_root + '/assets/createplus/img/step2.jpg'" class="center-block margin_top1" alt="">
        
          <table class="step">
            <tr class="step">
              <td>
                <ol>
                  <li value="4">印刷設定を確認して「アプリを起動して印刷する」を選択</li>
                </ol>
              </td>
            </tr>
          </table>

          <img :src="app_root + '/assets/createplus/img/step2.jpg'" class="center-block margin_top1" alt="">
        
          <table class="step">
            <tr class="step">
              <td>
                <ol>
                  <li value="5">出来上がり！</li>
                </ol>
              </td>
            </tr>
          </table>
          </div> -->

        <a id="qa" class="anchor"></a>
        <div class="wrap_text anchor">
          <CreateplusMessage fcontId="0" flinkId="1" msgkey="23" />
        </div>
        
        <dl class="question">
          <dt>
            <!-- Q. [アプリを起動して印刷する]を選択しても、アプリが起動しません -->
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="24" />
          </dt>
          <dd>
            <!-- A. お使いのデバイスにEpson Creative Print、またはEpson Photo＋がインストールされていることを確認してください。また、アプリが最新のバージョンにアップデートされていることを確認してください。 -->
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="25" />
            <br>
            <!-- スマホの場合は「Epson Creative Print」Ver.7.4以降、PCの場合は「Epson Photo+」Ver.3.8以降がインストールされているかを確認し、入っていない場合はインストールをお願いします。 -->
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="26" />
            <br>
            <a href="#appdl">
              <CreateplusMessage fcontId="0" flinkId="1" msgkey="21" />&nbsp;&raquo;
            </a>
            <br>
            <br>
            <!-- Androidデバイスをお使いの方で、最新Ver.のアプリがインストールされているのに起動しない場合は、ブラウザの設定で「PC版サイト」がONになっていないかご確認ください。
            ONになっている場合は、OFFにしてから[アプリを起動して印刷する]を選択してください。  -->
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="27" />
          </dd>
        </dl>
      

      </div>
      <!-- /container -->
    </div>
    <!-- fun_container" -->
  </BaseCommonPage>
</template>

<script>
import BaseCommonPage from "./BaseCommonPage";
import CreateplusMessage from "../components/CreateplusMessage";
import CreatePlusBreadcrumbs from '../components/CreatePlusBreadcrumbs';
import CreateAppDownloadCreative from "../components/CreateAppDownloadCreative";
import CreateAppDownloadPhotoPlus from "../components/CreateAppDownloadPhotoPlus";

export default {
  name: "CreatePlusGuide",
  props: {},
  components: {
    BaseCommonPage,
    CreateplusMessage,
    CreatePlusBreadcrumbs,
    CreateAppDownloadCreative,
    CreateAppDownloadPhotoPlus
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT,
    };
  },
  mounted() {
    this.$nextTick(function () {
      const hash = this.$route.hash;
      if (hash && hash.match(/^#.+$/)) {
        setTimeout(() => {
          this.$scrollTo(hash);
        }, 100)
      }
    })
  },
  metaInfo() {
    return {
      title: "Epson Setup Navi",
      meta: [
        {
          name: "description",
          content: this.$store.state.messages.messages["0-141"],
        },
      ],
      link: [
        {
          rel: "stylesheet",
          href:
            process.env.VUE_APP_ROOT + "/assets/createplus/css/createplus.css",
        },
        {
          rel: "stylesheet",
          href: "https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css",
        },
      ],
    };
  },
};
</script>

<style scoped>
.install_img {
  padding: 0px;
}

.app_badge {
  margin-top: 20px;
}

#guide_title {
  font-size: 22px;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: 25px;
}

.subtitle {
  font-weight: bold;
  font-size: 1.5rem;
  margin-bottom: 15px;
}

hr {
  margin-top: 0;
}

.wrap_text {
  font-size: 18px;
  color: #5a5a5a;
  border: solid 2px #5a5a5a;
  text-decoration: none;
  font-weight: bold;
  padding: 10px;
  margin: 30px 15% 10px 15%;
  text-align: center;
}

/* .margin_top1{
  margin-top: 20px;
} */

h3.fontsize{
  font-size:20px;
}

table.step {
  margin-top: 30px;
}

tr.step{
  margin-top: 15px;
}

.margin_top1{
  margin-top: 10px;
}

/* よくある質問 */
.question dt{
  font-weight: bold;
  margin-top: 30px;
}
.question dd{
  background: #e0e0e0;
  padding: 15px;
  margin: 15px 0;
}

</style>